import React, { createContext, useContext, useState } from 'react';

export type DateRangeKey = '7d' | '30d' | '90d' | '365d' | 'all';

export interface DateRangeOption {
  key: DateRangeKey;
  label: string;
  days: number | null;
}

export const DATE_RANGE_OPTIONS: DateRangeOption[] = [
  { key: '7d', label: 'Last 7 Days', days: 7 },
  { key: '30d', label: 'Last 30 Days', days: 30 },
  { key: '90d', label: 'Last 90 Days', days: 90 },
  { key: '365d', label: 'Last 12 Months', days: 365 },
  { key: 'all', label: 'All Time', days: null },
];

interface DateRangeContextValue {
  range: DateRangeOption;
  setRangeByKey: (key: DateRangeKey) => void;
}

const DateRangeContext = createContext<DateRangeContextValue | undefined>(undefined);

export const DateRangeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [range, setRange] = useState<DateRangeOption>(DATE_RANGE_OPTIONS[1]); // default Last 30 Days

  const setRangeByKey = (key: DateRangeKey) => {
    const found = DATE_RANGE_OPTIONS.find(o => o.key === key);
    if (found) setRange(found);
  };

  return (
    <DateRangeContext.Provider value={{ range, setRangeByKey }}>
      {children}
    </DateRangeContext.Provider>
  );
};

export const useDateRange = () => {
  const ctx = useContext(DateRangeContext);
  if (!ctx) throw new Error('useDateRange must be used within a DateRangeProvider');
  return ctx;
};
